import React from 'react'
import user from "../../asstes/images/user.png"
import logo from "../../asstes/images/logo.png";
import mobileLogo from "../../asstes/images/mobileLogo.png";
import { Link } from 'react-router-dom';

const ProfileNav = () => {
  return (
    <div className=' shadow-lg bg-white lg:h-[100px] h-[66px] fixed w-[100%] z-20 lg:flex hidden items-center'>
    <div className="container">
       <div className='flex items-center justify-between'>
          <div className='logo -mt-2'>
              <Link className=" hidden lg:flex" to={"/"}><img src={logo}  alt=""/></Link>
              <Link className=" lg:hidden" to={"/"}><img src={mobileLogo}  alt=""/></Link>
          </div>

            <div className='flex items-center gap-2'>
                <p className='text-[24px] font-normal'>¿Aún no eres usuario de ciberconta?</p>
                <img src={user} alt="" className='w-[30px]'/>
            </div>
      </div> 
    </div>
</div>
  )
}

export default ProfileNav